import { State } from '../state';

export const isActivityStarted = (state: State): boolean =>
  state.ui.isActivityStarted;

export const isMobileDevice = (state: State) => state.ui.isMobileDevice;
